import type * as React from 'react';

import { OverlayFocusContainedContext, ScreenTypeProvider } from '@gitbook/spine-react';

import { UsingKeyboardContextProvider } from './Events';
import { Palette, useIsPaletteOpened } from './Palette';
import { ThemeConfigurationProvider } from './theme';

type UIKitProviderProps = {
    children: React.ReactNode;
};

/**
 * Provider for all the contexts.
 */
export function UIKitProvider(props: UIKitProviderProps): React.ReactElement {
    const { children } = props;
    const isPaletteOpened = useIsPaletteOpened();
    return (
        <ThemeConfigurationProvider>
            <ScreenTypeProvider>
                <UsingKeyboardContextProvider>
                    <OverlayFocusContainedContext.Provider value={!isPaletteOpened}>
                        <Palette />
                        {children}
                    </OverlayFocusContainedContext.Provider>
                </UsingKeyboardContextProvider>
            </ScreenTypeProvider>
        </ThemeConfigurationProvider>
    );
}
